import React from 'react';

const RecordsLoader = ({ text = 'Loading, please wait...' }) => (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-60 z-50 flex flex-col items-center justify-center">
        <div className="animate-spin inline-block w-16 h-16 border-4 rounded-full border-blue-500 border-t-transparent mb-4"></div>
        <p className="text-white text-lg font-semibold">{text}</p>
    </div>
);

export default RecordsLoader;
